import type { ReactNode } from 'react';

export function HeroChip({ children, tone }: { children: ReactNode; tone?: string }) {
  return (
    <span
      style={{
        background: tone ?? 'rgba(255,255,255,.15)', color: '#fff',
        padding: '4px 12px', borderRadius: 999, fontSize: 13,
        display: 'inline-flex', alignItems: 'center', gap: 6,
      }}
    >
      {children}
    </span>
  );
}

interface PageHeroProps {
  icon: ReactNode;
  title: string;
  subtitle?: string;
  chips?: ReactNode[];
  actions?: ReactNode;
  from?: string;
  to?: string;
}

export function PageHero({ icon, title, subtitle, chips, actions, from = '#4f46e5', to = '#7c3aed' }: PageHeroProps) {
  return (
    <div style={{ background: `linear-gradient(120deg,${from},${to})`, borderRadius: 16, padding: '22px 24px', marginBottom: 20, color: '#fff' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, flex: 1, minWidth: 0 }}>
          <span style={{ fontSize: 22, display: 'inline-flex' }}>{icon}</span>
          <div>
            <div style={{ fontSize: 22, fontWeight: 700 }}>{title}</div>
            {subtitle && <div style={{ opacity: 0.9, fontSize: 13 }}>{subtitle}</div>}
          </div>
        </div>
        {actions && <div>{actions}</div>}
      </div>
      {chips && chips.length > 0 && (
        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginTop: 14 }}>
          {chips.map((c, i) => <span key={i}>{c}</span>)}
        </div>
      )}
    </div>
  );
}
